export default "__VITE_ASSET__C2FECluE__"